import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/shared/ui/dialog";
import { Button } from "@/shared/ui/button";
import { Input } from "@/shared/ui/input";
import { useState, useEffect, useId } from "react";
import type { CreateCompanyRequest } from "@/services/api/companies";

interface CompanyCreateDialogProps {
  open: boolean;
  isLoading?: boolean;
  onOpenChange: (open: boolean) => void;
  onSubmit: (data: CreateCompanyRequest) => void;
}

export function CompanyCreateDialog({
  open,
  isLoading,
  onOpenChange,
  onSubmit,
}: CompanyCreateDialogProps) {
  const [name, setName] = useState("");
  const [linkedInUrl, setLinkedInUrl] = useState("");

  useEffect(() => {
    if (open) {
      setName("");
      setLinkedInUrl("");
    }
  }, [open]);

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    if (!name.trim() || !linkedInUrl.trim()) return;

    onSubmit({
      name: name.trim(),
      linkedInUrl: linkedInUrl.trim(),
    });
  };
  const descriptionId = useId();

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent aria-describedby={descriptionId}>
        <DialogHeader>
          <DialogTitle>Add new company</DialogTitle>
          <DialogDescription>
            Create a new company to track and manage.
          </DialogDescription>
        </DialogHeader>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="space-y-2">
            <label className="text-sm font-medium text-ink-800">
              Company name
            </label>
            <Input
              autoFocus
              value={name}
              onChange={(event) => setName(event.target.value)}
              placeholder="Enter company name"
            />
          </div>

          <div className="space-y-2">
            <label className="text-sm font-medium text-ink-800">
              LinkedIn URL
            </label>
            <Input
              value={linkedInUrl}
              onChange={(event) => setLinkedInUrl(event.target.value)}
              placeholder="https://www.linkedin.com/company/..."
            />
          </div>

          <DialogFooter className="mt-4">
            <Button
              type="button"
              variant="outline"
              onClick={() => onOpenChange(false)}
              disabled={isLoading}
            >
              Cancel
            </Button>
            <Button
              type="submit"
              disabled={isLoading || !name.trim() || !linkedInUrl.trim()}
            >
              Create company
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
